// extracted by mini-css-extract-plugin
export var orderDetails = "_ux-2";
export var orderImage = "_ux-1";
export var orderMeta = "_ux-3";
export var orderSummary = "_ux-0";
export var rightArrow = "_ux-4";